import AnalyticCard from "../../analyticCard/analyticCard";

const DriversCards = () => {
    return(
        <ul className="grid col-4">
            <AnalyticCard data={{number: 23, title: <span>Risky<br/> Drivers</span>}}/>
            <AnalyticCard color={'#35A2E0'}
                          backColor={'#F5F5F5'}
                          data={{number: '4.0', title: <span>Average<br/> Score</span>}}/>
            <AnalyticCard color={'#36BA6E'}
                          backColor={'#E3F5EA'}
                          data={{number: 349, title: <span>Active<br/> Drivers</span>}}/>
            <AnalyticCard color={'#6088D0'}
                          backColor={'#F5F5F5'}
                          data={{number: '92%', title: <span>Produc-<br/>tivity</span>}}/>
        </ul>
    )
}

export default DriversCards;
